import Bloc from './Bloc.js';
import Types from './Types.js';

export default class Exile extends Bloc {

	constructor (src, ctx) {

		super("exile", src, ctx, true);
		this.f = (src, ins) => {
			ins[0].exile();
			return [];
		};
		this.types = [Types.card];
	}
}